export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8599.ee1ac4e2.jpg";